import { Button } from '@mui/material'
import { FC } from 'react'
import { useCreatePath, useTranslate } from 'react-admin'
import { Link } from 'react-router-dom'

import type { BombeoDetails, SpecialEventType } from '@/data'
import type { ScaleRecord } from '@/data/source'

import { SpecialEventIcon } from '../atoms/SpecialEventIcon'

export const AddSpecialEventButton: FC<{
  scale: ScaleRecord
  type: SpecialEventType
  prefill?: Partial<BombeoDetails>
}> = ({ scale, type, prefill }) => {
  const translate = useTranslate()
  const createPath = useCreatePath()
  return (
    <Button
      variant="outlined"
      color="inherit"
      component={Link}
      to={createPath({ resource: 'scale_events', type: 'create' })}
      state={{ record: { scaleRecordId: scale.id, scaleId: scale.scaleId, year: scale.year, type, ...prefill } }}
      startIcon={<SpecialEventIcon type={type} done size={20} />}
      data-testid={`special-event-button-${type}`}
      sx={{ textTransform: 'none', fontWeight: 600 }}
    >
      {translate('pages.scales.add_special', { type: translate(`enums.ScaleEventType.${type}`) })}
    </Button>
  )
}
